module.exports = __webpack_public_path__ + "img/logo-groupe-emc.c9f201fa.svg";